import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import withCurrentUser from '../hoc/withCurrentUser';
import PropTypes from 'prop-types';

const sx = StyleSheet.create({
	container: {
		backgroundColor: '#FFFBEB',
		border: '1px solid #FDE68A',
		borderLeft: '4px solid #FBBF24',
		borderRadius: '4px',
		padding: '10px 16px',
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
        marginBottom: '10px',
		marginLeft: 'auto',
        marginTop: '10px',
        marginRight: '16px',
		width: 'fit-content',
	},
	text: {
		margin: 0,
		fontFamily: 'Elevance Sans',
		fontWeight: 500,
		fontSize: '14px',
		color: '#92400E',
	},
});

const ProfileUpdateAlert = ({ currentUser, loadingCurrentUser }) => {
  if (loadingCurrentUser) return null;

  const hasFirstName = Boolean(currentUser?.first_name?.trim());
  const hasLastName = Boolean(currentUser?.last_name?.trim());
  const hasRequiredNames = hasFirstName && hasLastName;

  if (hasRequiredNames) return null;

  return (
    <div className={css(sx.container)}>
      <p className={css(sx.text)}>
        Please update the missing fields in your user profile.
      </p>
    </div>
  );
};

ProfileUpdateAlert.propTypes = {
  currentUser: PropTypes.object,
  loadingCurrentUser: PropTypes.bool,
};

export default withCurrentUser(ProfileUpdateAlert);